module.exports = __webpack_public_path__ + "mo.svg?a60c624ee0c8221860149536a7a25beb";


//////////////////
// WEBPACK FOOTER
// ./src/images/flags/4x3/mo.svg
// module id = 1323
// module chunks = 27